import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const FeaturesArray = ({ features, setFeatures }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newFeaturesArray = features.map((feature) => {
      if (feature.id !== id) return feature;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...feature,
          [inputName]: {
            ...feature?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...feature, [name]: value };
    });

    setFeatures(newFeaturesArray);
  };

  const removeFeature = (featureId) => {
    const newFeatures = features.filter(
      (feature, index) => feature.id !== featureId
    );
    setFeatures(() => newFeatures);
  };

  const addFeature = () => {
    setFeatures(() => [...features, { id: v4(), title: {}, description: {} }]);
  };

  return (
    <div className="form-group branches features_">
      <Row>
        <Col lg={12}>
          <h5>
            <FormattedMessage id={"all-features"} />
          </h5>

          {features.map((feature, index) => {
            return (
              <div key={feature.id} className="add-multi-component">
                <button
                  type="button"
                  onClick={() => removeFeature(feature.id)}
                  className="removeImg"
                >
                  <img src={removeImg} alt="" />
                </button>
                <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        {" "}
                        <FormattedMessage id={"title"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <input
                        type="text"
                        name="title.ar"
                        className="form-control form-outline"
                        onChange={(e) => handleInputOnChange(e, feature.id)}
                        value={feature?.title.ar}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        {" "}
                        <FormattedMessage id={"title"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        name="title.en"
                        className="form-control form-outline"
                        onChange={(e) => handleInputOnChange(e, feature.id)}
                        value={feature?.title.en}
                        dir="ltr"
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <h5>
                      {" "}
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"arabic-language"} /> )
                    </h5>
                    <textarea
                      type="text"
                      name="description.ar"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, feature.id)}
                      value={feature?.description?.ar}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <h5>
                      {" "}
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"english-language"} /> )
                    </h5>
                    <textarea
                      type="text"
                      name="description.en"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, feature.id)}
                      value={feature?.description?.en}
                      dir="ltr"
                    />
                  </Col>
                </Row>
              </div>
            );
          })}
        </Col>

        <Col lg={4} xs={12} className="text-left">
          <button
            type="button"
            className="btn btn-green add_new_section__"
            onClick={() => {
              addFeature();
            }}
          >
            <FormattedMessage id={"addFeature"} />
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default FeaturesArray;
